import React from "react";
import CollapsibleGroup from "./CollapsibleGroup";
import GroupSection, { GroupItem } from "./GroupSection";
import ProductDetailCard from "./ProductDetailCard";
import { Task } from "./TaskManagement";
import "./TaskManagement.scss";



interface TaskDetailSidebarProps {
  selectedTask: Task | null;
  getQuickAccessItems: (category: "Kurzzeitpflege" | "Vollstationäre Pflege" | "Pflegedienst") => GroupItem[];
  onEdit: () => void;
  onClose: () => void;
}

const employees = [
  { id: "1", name: "Peter Meier" },
  { id: "2", name: "Petra Schmidt" },
  { id: "3", name: "Peter Schneider" },
  { id: "4", name: "Hans Schmidt" },
  { id: "5", name: "Maria Müller" },
];

const TaskDetailSidebar: React.FC<TaskDetailSidebarProps> = ({
  selectedTask,
  getQuickAccessItems,
  onEdit,
  onClose,
}) => {

  const [responsibleEmployee, setResponsibleEmployee] = React.useState<string>("Peter Meier");


  return (
    <div className="detail-sidebar-right">
      {selectedTask ? (
        <div className="task-details">
          <div className="task-info">

            <h2>{selectedTask.title}</h2>
            <p>Fällig bis: {selectedTask.dueDate}</p>
            <p>Zuständig: Peter Meier</p>
            <i className="fa-solid fa-close" onClick={onClose} />
          </div>
          <ProductDetailCard
            type="dropdown"
            title="Status"
            options={["Neu", "In Bearbeitung", "Gewonnen", "Geschlossen"]}
            content={
              selectedTask.status === "todo"
                ? "Neu"
                : selectedTask.status === "inProgress"
                  ? "In Bearbeitung"
                  : "Gewonnen"
            }
          />
          <ProductDetailCard
            type="dropdown"
            title="Priorität"
            options={["Hoch", "Mittel", "Niedrig"]}
            content={selectedTask.priority}
          />
          <ProductDetailCard
            type="dropdown"
            title="Kategorie"
            options={[
              "Kurzzeitpflege",
              "Vollstationäre Pflege",
              "Pflegedienst",
            ]}
            content={selectedTask.category}
          />
          {selectedTask.dueDate && (
            <ProductDetailCard
              type="text"
              title="Fälligkeitsdatum"
              content={selectedTask.dueDate}
            />
          )}
          <div className="product-detail-card">
            <div className="detail-title">Zuständiger Mitarbeiter</div>
            <select
              value={responsibleEmployee}
              onChange={(e) => setResponsibleEmployee(e.target.value)}
            >
              <option value="">Bitte wählen</option>
              {employees.map((employee) => (
                <option key={employee.id} value={employee.name}>
                  {employee.name}
                </option>
              ))}
            </select>
          </div>
          {selectedTask.description && (
            <ProductDetailCard
              type="textarea"
              title="Beschreibung"
              content={selectedTask.description}
            />
          )}
        </div>
      ) : (
        <CollapsibleGroup title="Schnellzugriff">
          <GroupSection
            title="Kurzzeitpflege"
            items={getQuickAccessItems("Kurzzeitpflege")}
          />
          <GroupSection
            title="Vollstationäre Pflege"
            items={getQuickAccessItems("Vollstationäre Pflege")}
          />
          <GroupSection
            title="Pflegedienst"
            items={getQuickAccessItems("Pflegedienst")}
          />
        </CollapsibleGroup>
      )}
    </div>
  );
};

export default TaskDetailSidebar;
